import React, { useEffect, useState } from 'react';
import { Alert, Form, Spinner, Table } from 'react-bootstrap';
import EmptyState from '../../components/EmptyState';
import accountApi from '../../services/accountApi';

function unwrapList(data) {
  if (Array.isArray(data)) return { results: data, count: data.length };
  return data || { results: [], count: 0 };
}

function PlatformAuditPage() {
  const [events, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [action, setAction] = useState('');
  const [actor, setActor] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (action.trim()) params.action = action.trim();
      if (actor.trim()) params.actor = actor.trim();
      const data = unwrapList(await accountApi.listPlatformAudit(params));
      setEvents(data.results || []);
      setCount(data.count ?? (data.results || []).length);
    } catch (err) {
      setError(err.message || 'Failed to load audit log');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h1 className="product-page-title">Platform Audit</h1>
      <p className="product-page-subtitle">Cross-tenant platform actions.</p>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="product-card mb-3">
        <Form
          className="row g-2 align-items-end"
          onSubmit={(e) => {
            e.preventDefault();
            load();
          }}
        >
          <div className="col-md-4">
            <Form.Label>Action</Form.Label>
            <Form.Control
              value={action}
              onChange={(e) => setAction(e.target.value)}
              placeholder="e.g. partner.onboarding"
            />
          </div>
          <div className="col-md-4">
            <Form.Label>Actor email</Form.Label>
            <Form.Control
              value={actor}
              onChange={(e) => setActor(e.target.value)}
              placeholder="operator@example.com"
            />
          </div>
          <div className="col-md-4">
            <button type="submit" className="btn btn-outline-primary w-100">
              Apply
            </button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-state">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading…
        </div>
      )}

      {!loading && (
        <div className="product-card">
          <div className="small text-muted mb-2">{count} event{count === 1 ? '' : 's'}</div>
          <Table responsive className="product-table" size="sm">
            <thead>
              <tr>
                <th>Action</th>
                <th>Actor</th>
                <th>Partner</th>
                <th>When</th>
              </tr>
            </thead>
            <tbody>
              {events.length === 0 ? (
                <tr>
                  <td colSpan={4}>
                    <EmptyState title="No audit events" description="Try clearing filters." />
                  </td>
                </tr>
              ) : (
                events.map((e) => (
                  <tr key={e.id}>
                    <td className="mono">{e.action}</td>
                    <td>{e.actor_email || e.actor_id || '—'}</td>
                    <td>
                      {e.partner_name || '—'}
                      {e.partner_id || e.tenant_id ? (
                        <div className="mono small text-muted">
                          {String(e.partner_id || e.tenant_id).slice(0, 8)}…
                        </div>
                      ) : null}
                    </td>
                    <td>{e.created_at ? new Date(e.created_at).toLocaleString() : '—'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
}

export default PlatformAuditPage;
